import { render, staticRenderFns } from "./gs-add-to-basket.vue?vue&type=template&id=f715ceee"
import script from "./gs-add-to-basket.vue?vue&type=script&lang=ts"
export * from "./gs-add-to-basket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports